import Card from "components/card";
import CardsAndapi from "./CardsAndApi";

const TicketsView = () => {
    return (
        <Card extra={"w-full h-full sm:overflow-auto px-6"}>
            <header className="relative flex items-center justify-between pt-4">
                <div className="text-xl font-bold text-navy-700 dark:text-white">
                    Mis viajes
                </div>

            </header>
            <div className="mt-8 overflow-x-scroll xl:overflow-x-hidden">
            <CardsAndapi/>
            </div>
        </Card>
    )

}

export default TicketsView